import { render, staticRenderFns } from "./chat-message-artefatos.vue?vue&type=template&id=6a30e758&scoped=true&"
import script from "./chat-message-artefatos.vue?vue&type=script&lang=js&"
export * from "./chat-message-artefatos.vue?vue&type=script&lang=js&"
import style0 from "./chat-message-artefatos.vue?vue&type=style&index=0&id=6a30e758&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a30e758",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a30e758')) {
      api.createRecord('6a30e758', component.options)
    } else {
      api.reload('6a30e758', component.options)
    }
    module.hot.accept("./chat-message-artefatos.vue?vue&type=template&id=6a30e758&scoped=true&", function () {
      api.rerender('6a30e758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/chat-message-artefatos/chat-message-artefatos.vue"
export default component.exports